export const META_CHAR_LIMITS = {
  title: 60,
  description: 160,
  ogTitle: 60,
  ogDescription: 200,
  twitterTitle: 70,
  twitterDescription: 200,
  ogSiteName: 40,
};

export function getCharCountStatus(length, max) {
  if (max == null || length == null) return null;
  if (length > max) return "error";
  if (length >= Math.floor(max * 0.9)) return "warn";
  return "ok";
}
